module.exports = __webpack_public_path__ + "static/lotus-e5833df51063e2ab702ffa3bc07a7000.png";